$(function(){
    var metingen = [];
    /*

    meting = { param1: 'Home', param2: 'Headbanner', param3: 'Bekijk assortiment', object: $('.banner-button[href="overige-stickers/"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Headbanner', param3: 'Direct ontwerpen', object: $('.banner-button[href="stickers-ontwerpen//"]')};
    metingen.push(meting);

    // sidebanner in code zelf
    meting = { param1: 'Home', param2: 'Klantenservice', param3: 'Meest gestelde vragen', object: $('#menu-klantenservice-uitklap a[title="Meest gestelde vragen"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Klantenservice', param3: 'Aanleverspecificaties', object: $('#menu-klantenservice-uitklap a[title="Aanleverspecificaties"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Klantenservice', param3: 'Werktekeningen', object: $('#menu-klantenservice-uitklap a[title="Werktekeningen"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Klantenservice', param3: 'Ons team', object: $('#menu-klantenservice-uitklap a[title="Ons team"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Klantenservice', param3: 'Onze klanten', object: $('#menu-klantenservice-uitklap a[title="Onze klanten"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Klantenservice', param3: 'Klantbeoordelingen', object: $('#menu-klantenservice-uitklap a[title="Klantbeoordelingen"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Klantenservice', param3: 'Contact', object: $('#menu-klantenservice-uitklap a[title="Contact"]')};
    metingen.push(meting);

    $('li.mainitem-container a').each(function(){
        meting = { param1: 'Home', param2: 'Assortiment', param3: $(this).attr('title'), object: $(this)};   
        metingen.push(meting);
    });
    $('#content-categorieen-links a').each(function(){
        meting = { param1: 'Home', param2: 'Assortiment', param3: $(this).attr('title'), object: $(this)};       
        metingen.push(meting);
    });

    // aanbiedingen in code zelf
    // offerte aanvragen in code zelf
    // sticker ontwepren in code zelf

    meting = { param1: 'Home', param2: 'Handige info', param3: 'Aanleverspecificaties', object: $('.footer-blok-ul a[title="Aanleverspecificaties"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Handige info', param3: 'Werktekeningen', object: $('.footer-blok-ul a[title="Werktekeningen"]')};
    metingen.push(meting);
    meting = { param1: 'Home', param2: 'Handige info', param3: 'Klantbeoordelingen', object: $('.footer-blok-ul a[title="Klantbeoordelingen"]')};
    metingen.push(meting);

    for(var i=0; i<metingen.length; i++)
    {
        var meting = metingen[i];
        var object = meting.object;
        if (typeof(object.attr('href')) !== undefined)
        {
            object.attr('onclick', 'ga("send", "event", "' + meting.param1 + '", "' + meting.param2 + '", "' + meting.param3 + '")');
        }
    }
    */
})
